import SelectListItem from "@molecules/Select/SelectListItem/SelectListItem"
import UserAvatar from "@molecules/UserAvatar/UserAvatar"

import { UserSelectListItemProps } from "./UserSelectListItem.types"

export default function UserSelectListItem<T extends string = string>(props: UserSelectListItemProps<T>) {
    const { user, item, hasSupportText, supportText, hasSubtext, subtext, ...rest } = props

    const baseProps = {
        variant: "default" as const,
        layout: "user" as const,
        item: {
            ...item,
            leading: <UserAvatar user={user} size="xl" />,
        },
        ...rest,
    }

    if (hasSupportText && supportText) {
        return <SelectListItem {...baseProps} hasSupportText={true} supportText={supportText} />
    }

    if (hasSubtext && subtext) {
        return <SelectListItem {...baseProps} hasSubtext={true} subtext={subtext} />
    }

    return <SelectListItem {...baseProps} />
}
